///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.attachments = abcsetup.attachments || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.attachments.width = null;
abcsetup.attachments.height = null;


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Global Initialize
//
///////////////////////////////////////////////////////////////////////////////////////////////////
$(function () {
    abcsetup.attachments.init();
});


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.attachments = {
    init: function () {
        abcsetup.attachments.width = $(window).width() - 200;
        abcsetup.attachments.height = $(window).height() - 100;

        // Straight attachment download buttons
        $('.attachment-link').each(function () {
            var url = $(this).attr('href').replace('download/', 'preview/');
            var title = $(this).text().trim();
            var previewClass = '';

            // Determine the button class to use on the preview link
            if ($(this).hasClass('btn-primary')) {
                previewClass = 'btn-primary';
            }
            if ($(this).hasClass('btn-warning')) {
                previewClass = 'btn-warning';
            }
            if ($(this).hasClass('btn-info')) {
                previewClass = 'btn-info';
            }

            $(this).wrap('<div class="btn-group"></div>');
            $(this).after('<a href="' + url + '" class="btn ' + previewClass + ' btn-attachment-preview" data-toggle="lightbox" data-title="' + title + '" data-footer="<a href=' + $(this).attr('href') + ' class=\'btn btn-primary\'>Download</a>" data-type="url" data-disable-external-check="true" data-width="' + abcsetup.attachments.width + '" data-height="' + abcsetup.attachments.height + '" data-alwaysShowClose="true" title="Preview"><i class="fas fa-search"></i></a>');
        });

        // Attachment thumb links
        $('.attachment-link-thumb').each(function () {
            var url = $(this).attr('href').replace('download/', 'preview/');
            var title = $(this).text().trim();
            //var title = $(this).find('small').text().trim();
            //title = title.find('small').remove().text().trim();

            $(this).find('img').wrap('<a href="' + url + '" class="" data-toggle="lightbox" data-title="' + title + '" data-footer="<button type=\'button\' class=\'btn btn-secondary toggle-size-btn\' data-last-height=\'auto\' data-last-width=\'auto\'>Toggle Size</button><a href=' + $(this).attr('href') + ' class=\'btn btn-primary\'>Download</a>" data-type="url" data-disable-external-check="true" data-width="' + abcsetup.attachments.width + '" data-height="' + abcsetup.attachments.height + '" data-alwaysShowClose="true" title="Preview"></a>');
        });
    },
}
